import { CancelOutlinedIcon } from '../../../../components';

function FailedIcon() {
  return (
    <span className='bg-danger-100 grid h-50 w-50 place-items-center rounded-[50%]'>
      <CancelOutlinedIcon className='text-danger-500 text-[120px]' />
    </span>
  );
}

export default FailedIcon;
